module.exports = __webpack_public_path__ + "static/media/holycross-logo.70140a74.png";